export default (length = 6) => Math.round(Math.random() * 10 ** length)
